// src/client/lib/loanDraft.ts
// Session-scoped draft for the apply→confirm→success flow. Cleared on
// success or when the user backs out to /home.
import type { Ngwee } from '@/lib/types';
import { LOAN_TERM_DAYS, type LoanTermDays } from '@/constants/config';

const KEY = 'client:loan-draft';

export interface LoanDraft {
  principalNgwee: number;
  termDays: LoanTermDays;
  purpose?: string;
}

export function saveLoanDraft(d: { principal: Ngwee; term: LoanTermDays; purpose?: string }): void {
  const draft: LoanDraft = { principalNgwee: Number(d.principal), termDays: d.term };
  if (d.purpose) draft.purpose = d.purpose;
  try {
    sessionStorage.setItem(KEY, JSON.stringify(draft));
  } catch {
    // Storage blocked (iOS private mode, etc). Continue navigation;
    // the user will see an empty draft on confirm and bounce back.
    // TODO: surface a toast in LoanApply once we have a story for storage-disabled.
  }
}

export function readLoanDraft(): LoanDraft | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const o = JSON.parse(raw) as Partial<LoanDraft>;
    if (typeof o.principalNgwee !== 'number' || !Number.isFinite(o.principalNgwee)) return null;
    if (!LOAN_TERM_DAYS.includes(o.termDays as LoanTermDays)) return null;
    return { principalNgwee: o.principalNgwee, termDays: o.termDays as LoanTermDays };
  } catch {
    return null;
  }
}

export function clearLoanDraft(): void {
  sessionStorage.removeItem(KEY);
}
